import { useMemo } from "react";
import defensiveConservative from "../static/icon--portfolio--defensive-conservative.svg";
import defensiveGrowth from "../static/icon--portfolio--defensive-growth.svg";
import defensiveModerate from "../static/icon--portfolio--defensive-moderate.svg";
import offensiveAggressive from "../static/icon--portfolio--offensive-aggressive.svg";
import offensiveConservative from "../static/icon--portfolio--offensive-conservative.svg";
import offensiveGrowth from "../static/icon--portfolio--offensive-growth.svg";
import offensiveModerate from "../static/icon--portfolio--offensive-moderate.svg";

const portfolioIconMap = {
  0: offensiveConservative,
  1: offensiveModerate,
  2: offensiveGrowth,
  3: offensiveAggressive,
  4: defensiveConservative,
  5: defensiveModerate,
  6: defensiveGrowth,
};

const usePortfolioIcon = (portfolioId) => {
  return useMemo(() => {
    // Handle undefined, null, or empty string portfolio IDs
    if (
      portfolioId === null ||
      portfolioId === undefined ||
      portfolioId === ""
    ) {
      console.log(
        "No portfolio ID provided, defaulting to defensive conservative (4)",
      );
      // Default to defensive conservative (4) if no ID is provided
      return portfolioIconMap[4];
    }

    try {
      console.log("Returning portfolio icon for ID:", portfolioId);
      return portfolioIconMap[portfolioId] || portfolioIconMap[4];
    } catch (e) {
      console.warn(`Portfolio icon not found for ID: ${portfolioId}`);
      // Default to defensive conservative (4) on error
      return portfolioIconMap[4];
    }
  }, [portfolioId]);
};

export default usePortfolioIcon;
